<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2020.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2020-12-26                                                         -
  ----------------------------------------------------------------------------->

<template>

</template>

<script>
import useIsObject from "../../../compositions/use-is-object";

export default {
  name: "yega1-axios-data-source",
  inject: {
    setItems: 'setItems',
    registerDataSource:'registerDataSource'
  },
  props:{
    storeName:{
      type:String,
      required:true
    },
    storeQuery:{
      type:Object,
      default:{}
    },
    initialLoad:{
      type: Boolean,
      default: true
    },
    slotData:{
      type:Object
    },
    filterFunc:{
      type: Function
    },
    sortFunc:{
      type: Function
    }
  },
  setup(){
    const { isObject } = useIsObject();
    return {
      isObject
    };
  },
  data(){
    return {
      merged_query:{},
      dispatch_timeout : null
    };
  },
  created(){
    if(this.initialLoad){
      this.loadItems({});
    }
    if(this.registerDataSource){
      this.registerDataSource(this);
    }
  },
  methods:{
    deepMergedQuery(query){
      let result = {...this.storeQuery, ...query};
      Object.keys(this.storeQuery).forEach((key)=>{
        let storeQueryValue = this.storeQuery[key];
        let queryValue = query[key];
        if(this.isObject(storeQueryValue) && this.isObject(queryValue)){
          result[key] = {...storeQueryValue,...queryValue};
        }
      });
      return result;
    },
    loadItems(query){
      console.log(`data source loadItems called. query:${JSON.stringify(query)}`)
      this.$emit('items-loading');
      this.merged_query = this.deepMergedQuery(query);
      if(this.dispatch_timeout){
        clearTimeout(this.dispatch_timeout);
      }
      let that = this;
      this.dispatch_timeout = setTimeout(()=>{
        that.callDispatch();
      });
    },
    callDispatch(){
      console.log(`data source callDispatch called. query:${JSON.stringify(this.merged_query)}`)
      this.$store.dispatch(`${this.storeName}/index`,this.merged_query)
          .then((items)=>{
            this.callSetItems(items);
            this.$emit('items-loaded',items);
          })
          .catch((error)=>{
            this.$emit('items-load-failed',error);
            alert(error.response ? error.response.data : error);
          });
    },
    callSetItems(items){
      let output_items;
      if(this.filterFunc){
        output_items = items.filter((item)=>{ return this.filterFunc(item)});
      }else if(this.sortFunc){
        output_items = items.sort(this.sortFunc);
      }else{
        output_items = items;
      }
      this.setItems(output_items);
    }
  }
}
</script>

<style scoped>

</style>
